import {IBaseApiConfig} from '@scalified-monorepo/ng-shared';

export const getBaseApiConfig = (apiUrl: string): IBaseApiConfig => ({
  auth: {
    command: {
      url: `${apiUrl}/auth/command`,
      method: 'POST',
    },
  },
  account: {
    command: {
      url: `${apiUrl}/account/command`,
      method: 'POST',
    },
    query: {
      url: `${apiUrl}/account/query`,
      method: 'POST',
    },
  },
  role: {
    command: {
      url: `${apiUrl}/role/command`,
      method: 'POST',
    },
    query: {
      url: `${apiUrl}/role/query`,
      method: 'POST',
    },
  },
  dynamicResource: {
    command: {
      url: `${apiUrl}/dynamic-resource/command`,
      method: 'POST',
    },
    query: {
      url: `${apiUrl}/dynamic-resource/query`,
      method: 'POST',
    },
  },
  logger: {
    transferLog: {
      url: `${apiUrl}/logger/transfer-log`,
      method: 'POST',
    },
  },
});
